import { useTranslation } from 'react-i18next';

import { TablePagination } from '@mui/material';

type Props = {
	count: number;
	page: number;
	rowsPerPage: number;
	rowsPerPageOptions: number[];
	onPageChange: (event: unknown, page: number) => void;
	onRowsPerPageChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

/**
 * A pagination for lists that are not a table, like the one `ResponsiveTable` renders on
 * mobile, which has none of its own.
 *
 * Its toolbar wraps instead of overflowing, so a phone 360 px wide never scrolls sideways.
 */
export default function WrappingPagination(props: Props) {
	const { t } = useTranslation();

	return (
		<TablePagination
			component="div"
			labelRowsPerPage={t('common:rowsPerPage')}
			{...props}
			sx={{
				overflow: 'hidden',
				'& .MuiTablePagination-toolbar': { flexWrap: 'wrap', justifyContent: 'flex-end', paddingLeft: 0, rowGap: 0.5 },
				'& .MuiTablePagination-spacer': { display: 'none' },
				'& .MuiTablePagination-input': { marginRight: 1 },
			}}
		/>
	);
}
